import React from "react";
import "./TpcBootcampOnlineDelivery.css";
import { ArrowRight, CalendarDays, Smartphone } from "lucide-react";

import learnerImage from "../../images/phone.webp";
import unityPhone from "../../images/unityMobileReal.png";

const marketCandles = [
  "green",
  "green",
  "red",
  "green",
  "gold",
  "red",
  "green",
  "green",
  "red",
  "green",
];

function TpcBootcampOnlineDelivery({
  applyHref = "https://andus.co.za/trade-register",
  nextCohortStart = "1 July 2026",
}) {
  return (
    <section
      id="tpc-bootcamp-online-delivery"
      className="trpc-onlineDeliveryIntro"
      aria-labelledby="trpc-onlineDeliveryIntro-title"
    >
      <div className="trpc-onlineDeliveryIntro__marketLayer" aria-hidden="true">
        <span className="trpc-onlineDeliveryIntro__priceLine trpc-onlineDeliveryIntro__priceLine--one" />
        <span className="trpc-onlineDeliveryIntro__priceLine trpc-onlineDeliveryIntro__priceLine--two" />

        <div className="trpc-onlineDeliveryIntro__candleGroup">
          {marketCandles.map((trend, index) => (
            <span
              key={`${trend}-${index}`}
              className="trpc-onlineDeliveryIntro__candle"
              data-trend={trend}
            />
          ))}
        </div>
      </div>

      <div className="trpc-onlineDeliveryIntro__shell">
        <div className="trpc-onlineDeliveryIntro__grid">
          <div
            className="trpc-onlineDeliveryIntro__visual"
            aria-label="Unity Learning mobile app preview"
          >
            <div className="trpc-onlineDeliveryIntro__visualStage">
              <div
                className="trpc-onlineDeliveryIntro__stageTerminalTop"
                aria-hidden="true"
              >
                <span />
                <span />
                <span />
              </div>

              <div
                className="trpc-onlineDeliveryIntro__visualHalo"
                aria-hidden="true"
              />

              <div
                className="trpc-onlineDeliveryIntro__shapeBack"
                aria-hidden="true"
              />

              <div
                className="trpc-onlineDeliveryIntro__shapeFront"
                aria-hidden="true"
              />

              <div
                className="trpc-onlineDeliveryIntro__stagePriceLine"
                aria-hidden="true"
              />

              <svg
                className="trpc-onlineDeliveryIntro__connectors"
                viewBox="0 0 690 560"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="trpc-onlineDeliveryIntro__connectorLine"
                  d="M270 156 H388 V116 H522"
                />
                <circle
                  className="trpc-onlineDeliveryIntro__connectorDot"
                  cx="270"
                  cy="156"
                  r="7"
                />

                <path
                  className="trpc-onlineDeliveryIntro__connectorLine"
                  d="M324 392 H446 V424 H552"
                />
                <circle
                  className="trpc-onlineDeliveryIntro__connectorDot"
                  cx="324"
                  cy="392"
                  r="7"
                />
              </svg>

              <img
                className="trpc-onlineDeliveryIntro__phone"
                src={unityPhone}
                alt="Unity Learning app preview"
                loading="lazy"
                decoding="async"
              />

              <img
                className="trpc-onlineDeliveryIntro__learner"
                src={learnerImage}
                alt="Learner using a mobile learning app"
                loading="lazy"
                decoding="async"
              />

              <div className="trpc-onlineDeliveryIntro__badge trpc-onlineDeliveryIntro__badgeTop">
                <span
                  className="trpc-onlineDeliveryIntro__badgeIcon"
                  aria-hidden="true"
                >
                  <Smartphone size={18} strokeWidth={2.35} />
                </span>

                <span className="trpc-onlineDeliveryIntro__badgeCopy">
                  <span className="trpc-onlineDeliveryIntro__badgeKicker">
                    Unity Learning
                  </span>
                  <strong>Your bootcamp learning hub</strong>
                </span>
              </div>

              <div className="trpc-onlineDeliveryIntro__badge trpc-onlineDeliveryIntro__badgeBottom">
                <span
                  className="trpc-onlineDeliveryIntro__badgeIcon"
                  aria-hidden="true"
                >
                  <CalendarDays size={18} strokeWidth={2.35} />
                </span>

                <span className="trpc-onlineDeliveryIntro__badgeCopy">
                  <span className="trpc-onlineDeliveryIntro__badgeKicker">
                    Next intake
                  </span>
                  <strong>{nextCohortStart}</strong>
                </span>
              </div>
            </div>
          </div>

          <div className="trpc-onlineDeliveryIntro__copy">
            <div
              className="trpc-onlineDeliveryIntro__copyTerminalTop"
              aria-hidden="true"
            >
              <span />
              <span />
              <span />
            </div>

            <div className="trpc-onlineDeliveryIntro__kicker">
              Next Bootcamp Cohort
            </div>

            <h2
              id="trpc-onlineDeliveryIntro-title"
              className="trpc-onlineDeliveryIntro__title"
            >
              Start your Price Action Trader Bootcamp online.
            </h2>

            <p className="trpc-onlineDeliveryIntro__lead">
              Join the next TPC Price Action Trader Bootcamp cohort and begin a
              structured, part-time route into market literacy, disciplined
              execution and price action trading.
            </p>

            <div
              className="trpc-onlineDeliveryIntro__startCard"
              aria-label="Next cohort start date"
            >
              <span
                className="trpc-onlineDeliveryIntro__startIcon"
                aria-hidden="true"
              >
                <CalendarDays size={21} />
              </span>

              <div>
                <span className="trpc-onlineDeliveryIntro__startLabel">
                  Next Cohort Starts
                </span>
                <strong>{nextCohortStart}</strong>
              </div>
            </div>

            <div className="trpc-onlineDeliveryIntro__ctaRow">
              <a
                href={applyHref}
                target="_blank"
                rel="noopener noreferrer"
                className="trpc-onlineDeliveryIntro__btn trpc-onlineDeliveryIntro__btnPrimary"
                data-candle="green"
              >
                <span>Apply for the Next Cohort</span>
                <ArrowRight size={18} aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TpcBootcampOnlineDelivery;
